<template>
  <div>
    <div class="e-filter-container">
      <a v-b-toggle.sidebar-right.sidebar-backdrop class="e-filter-btn"><i class="lnr lnr-chevron-left-circle"></i></a>
    </div>
    <request-details-component :RequestDetailsData="investigatingRequest"></request-details-component>
    <div class="e-loader-back" v-if="loading">
            <div class="e-loader-content">
              <div class="ball-clip-rotate-multiple">
                <div></div>
                <div></div>
              </div>
              <div class="e-nusx-8 e-bold e-loader-text">იტვირთება...</div>
            </div>
          </div>
    <!-- <h4 class="d-flex justify-content-between align-items-center w-100 font-weight-bold py-1">
      <div class="e-mtavr-17 e-ts-09rem">მოთხოვნის დეტალები</div>
    </h4> -->
    <div class="container-m-nx border-right-0 border-left-0 ui-bordered mb-4">
      <div class="row no-gutters row-bordered row-border-light">
        <div class="col-md-9">
          <div class="media-body container-p-x py-1 mt-1 mb-1">
            <button type="button" class="btn btn-secondary btn-xs e-mtavr-17" @click="StopInvestigating"><span class="lnr lnr-chevron-left-circle"></span>&nbsp;&nbsp;უკან</button>
            <button v-if="investigatingRequest.status === 1" type="button" class="btn btn-warning btn-xs e-mtavr-17" @click="setRequestStatus(investigatingRequest.id, 2)"><span class="lnr lnr-pushpin"></span>&nbsp;&nbsp;დავამუშავებ</button>
            <button v-if="investigatingRequest.status === 2" type="button" class="btn btn-success btn-xs e-mtavr-17" v-b-modal.WLBLItemModal @click="WHBL_item.ListType = 'Approve'"><span class="lnr lnr-checkmark-circle"></span>&nbsp;&nbsp;დადასტურება</button>
            <!-- <button v-if="investigatingRequest.status === 2" type="button" class="btn btn-success e-mtavr-17" v-b-modal.WLBLItemModal @click="setRequestStatus(investigatingRequest.id, 5)"><span class="lnr lnr-checkmark-circle"></span>&nbsp;&nbsp;დადასტურება</button> -->
            <button v-if="investigatingRequest.status === 2" type="button" class="btn btn-danger btn-xs e-mtavr-17" v-b-modal.WLBLItemModal @click="WHBL_item.ListType = 'Blocked'"><span class="lnr lnr-cross-circle"></span>&nbsp;&nbsp;დაბლოკვა</button>
            <!-- <button v-if="investigatingRequest.status === 2" type="button" class="btn btn-danger e-mtavr-17" @click="setRequestStatus(investigatingRequest.id, 4)"><span class="lnr lnr-cross-circle"></span>&nbsp;&nbsp;დაბლოკვა</button> -->
            <!-- <b-button v-if="investigatingRequest.status === 2" type="button" class="btn btn-default e-mtavr-17" v-b-modal.WLBLItemModal @click="WHBL_item.ListType = 'white'"><span class="lnr lnr-indent-increase"></span>&nbsp;&nbsp;დაამატე თეთრ სიაში</b-button> -->
            <!-- <button v-if="investigatingRequest.status === 2" type="button" class="btn btn-dark e-mtavr-17" v-b-modal.WLBLItemModal @click="WHBL_item.ListType = 'Black'"><span class="lnr lnr-indent-increase"></span>&nbsp;&nbsp;დაამატე შავ სიაში</button> -->
            <!-- <button type="button" class="btn btn-danger e-mtavr-17" @click="setRequestStatus(investigatingRequest.id, 1)"><span class="lnr lnr-cross-circle"></span>&nbsp;&nbsp;დაბლოკვა</button> -->
          </div>
        </div>
        <div class="col-md-3">
          <div class="container-p-x py-1 justify-content-between">
            <div class="e-mtavr-17"><span class="text-muted">სტატუსი: &nbsp;</span><strong class="e-nusx-7" :class="`text-green`">{{investigatingRequest.statusText}}</strong></div>
          </div>
        </div>
        <!-- <div class="col-md-3">
          <div class="container-p-x py-1 mt-1 mb-1">
            <div class="text-muted small e-mtavr-17">სტატუსი</div>
            <strong class="text-big e-nusx-8" :class="`text-green`">{{investigatingRequest.statusText}}</strong>
          </div>
        </div> -->
      </div>
    </div>
    <div class="row">
      <div class="col col-md-12 col-lg-12 col-sm-12 col-xl-12 col-xs-12">
        <div class="card mb-4">
          <b-card-header>
          <div class="row">
              <div class="col col-6">
                <h6 class="e-nusx-5 mb-0 mt-1">დამთხვევების სია</h6>
              </div>
              <div class="col col-6 text-right">
                <button class="btn btn-sm btn-primary" @click="generatePDF()"><span class="far fa-file-pdf"></span> PDF</button>
              </div>
            </div>
          </b-card-header>
          <div class="card-body">
            <vue-good-table
            ref="requestsTable"
            :columns="apiVersion === 'V1' ? investigatingRequest.juridicalStatusId === 1 ? MTCH_Table_ColumnsNew : MTCH_Table_ColumnsNew_ent : MTCH_Table_Columns"
            :rows="MTCH_Table_Rows"
            class="vgt-table bordered condensed e-table-1 e-dynamic-filter e-ts-07rem"
            :search-options="{enabled: true, placeholder: 'ძებნის პარამეტრი'}"
            :sort-options="{enabled: true, initialSortBy: {field: 'score', type: 'desc'}}"
            :select-options="{
              enabled: true,
              selectOnCheckboxOnly: true,
              disableSelectInfo: true
               }"
            :pagination-options="{
                                    enabled: true,
                                    mode: 'records',
                                    perPage: 5,
                                    position: 'top',
                                    perPageDropdown: [50, 75, 100],
                                    dropdownAllowAll: false,
                                    setCurrentPage: 1,
                                    nextLabel: 'შემდეგი',
                                    prevLabel: 'წინა',
                                    rowsPerPageLabel: 'ნაჩვენები ჩანაწერების რაოდენობა',
                                    ofLabel: '-ჩანაწერი სულ',
                                    pageLabel: 'გვერდი', // for 'pages' mode
                                    allLabel: 'ყველა',
                                  }"
          >
          <template slot="table-row" slot-scope="props">
              <div v-if="props.column.field == 'Nationality'">
                <div v-if="investigatingRequest.juridicalStatusId === 1">
                  <ul class="list-unstyled" v-if="apiVersion === 'V1'">
                    <li v-for="natio in props.row.Nationality"  :key="natio.$index">{{ natio }}</li>
                  </ul>
                  <ul class="list-unstyled" v-else>
                    <li v-for="natio in props.row.Nationality"  :key="natio.$index">{{ natio }}</li>
                  </ul>
                </div>
                <div v-if="investigatingRequest.juridicalStatusId === 2">
                  <ul class="list-unstyled" v-if="apiVersion === 'V1'">
                    <li v-for="natio in props.row.Nationality"  :key="natio.id">{{ natio.countryName }}</li>
                  </ul>
                  <!-- {{props.row}} -->
                  <ul class="list-unstyled" v-else>
                    <li v-for="natio in props.row.Nationality"  :key="natio.id">{{ natio.countryName }}</li>
                  </ul>
                </div>
              </div>
               <div v-else-if="props.column.field == 'AdditionalNotes'" class="text-left">
                <ul class="list-unstyled">
                  <li v-for="n in props.row.distData" :key="n.$index">
                      <!-- <div v-for="c in n.categories" :key="c.name" class="badge badge-outline-danger ml-1 mr-1">{{c.name}}</div> -->
                      <div class="badge badge-outline-danger ml-1 mr-1 float-left">{{n}}</div>
                  </li>
                </ul>
                <ul class="list-unstyled">
                  <li v-for="n in props.row.datasets" :key="n.$index">
                      <!-- <div v-for="c in n.categories" :key="c.name" class="badge badge-outline-danger ml-1 mr-1">{{c.name}}</div> -->
                      <div class="badge badge-outline-danger ml-1 mb-1 float-left">{{n}}</div>
                  </li>
                </ul>
              </div>
              <div v-else-if="props.column.field == 'NameAlias'">
                  <span>{{ props.row.name}}</span><br/>
                  <span class="badge badge-secondary e-eng-font"><small>Alias Match: </small>{{ props.row.match }}</span>
                </div>
              <div v-else-if="props.column.field == 'BirthDate'">
                <ul class="list-unstyled" v-if="apiVersion === 'V1'">
                  <li v-for="bd in props.row.datesOfBirth"  v-bind:key="bd.$index">{{ bd }}</li>
                </ul>
              </div>
              <div v-else-if="props.column.field == 'Image'" class="text-center">
                  <img v-bind:src="props.row.profileImage" :id="props.row.qrCode" class="e-max-width-70">
                  <b-popover id="primaryPopover-container" container="primaryPopover-container" :target="props.row.qrCode" custom-class="popover" placement="right" triggers="hover focus">
                    <template #title> <span class="e-nusx-7">სურათის ორიგინალი</span></template>
                    <template>
                      <b-container fluid class="p-0 w-auto">
                        <div class="row">
                          <div class="col col-12">
                            <img v-bind:src="props.row.profileImage" class="img-fluid">
                          </div>
                        </div>
                      </b-container>
                  </template>
                  </b-popover>
                  <!-- <b-tooltip triggers="hover" target="tooltip-target-1" placement="right" class="b-tooltip-light tooltip-right">
                    <div class="col col-12">
                    <img v-bind:src="props.row.profileImage">
                    </div>
                  </b-tooltip> -->
                </div>
              <div v-else-if="props.column.field == 'DataCollectedDate'" class="text-left">
                <ul class="list-unstyled">
                  <li v-for="n in props.row.articles" :key="n.text">
                      {{n.dateCollected}}
                  </li>
                </ul>
              </div>
              <div v-else-if="props.column.field == 'functions'" class="text-left">
                <!-- <button type="button" class="btn btn-outline-danger icon-btn borderless" @click="ShowPersonalDetails(props.row)"><span class="lnr lnr-magnifier"></span></button> -->
                <button v-if="apiVersion === 0" type="button" class="btn btn-outline-danger icon-btn borderless" @click="ShowPersonalDetails(props.row)"><span class="lnr lnr-magnifier"></span></button>
                <button v-else type="button" class="btn btn-outline-danger icon-btn borderless" @click="loadProfile(props.row)"><span class="lnr lnr-magnifier"></span></button>
              </div>
              <!-- <div v-else-if="props.column.field == 'functions'" class="e-whitespace-nowrap">
                <button
                  class="btn btn-info icon-btn btn-sm"
                  title="სკანირების რეზულტატების ნახვა"
                  v-if="props.row.matchCount > 0"
                >
                  <span class="lnr lnr-magnifier"></span>
                </button>
              </div> -->
            </template>
          </vue-good-table>
          </div>
        </div>
        <individual-details v-if="apiVersion === 'V1' && showPersonalDetails" :curTab="curTab" @changeTab="changeTab" :personDetails="personDetails" :investigatingRequest="investigatingRequest"></individual-details>
        <business-detailsv3 v-if="showBusinessDetails && apiVersion === 'V1'" :curTabbd="curTabbd" @changeTabbd="changeTabbd" :businessDetails="businessDetails" :investigatingRequest="investigatingRequest"></business-detailsv3>
        <personal-details v-if="apiVersion === 0 && showPersonalDetails" :personDetails="personDetails" :investigatingRequest="investigatingRequest"></personal-details>
        <business-details v-if="showBusinessDetails && apiVersion === 0" :businessDetails="businessDetails" :investigatingRequest="investigatingRequest"></business-details>
      </div>
    </div>
    <add-to-wl-bl-item @RecordAdded="loadRequestDetails" :DataStream="WHBL_item"></add-to-wl-bl-item>
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      filename="MatchingTable"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      :pdf-margin="10"
      pdf-orientation="Landscape"
      pdf-content-width="100%"
      @progress="onProgress($event)"
      ref="html2Pdf"
    >
    <section slot="pdf-content">
      <div class="row bg-white">
        <div class="col col-3 pt-3 pb-3 pl-3">
          <div class="d-flex justify-content-left align-items-center h-100">
            <svg version="1.2" baseProfile="tiny" id="Layer_3" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 167.7 182.6" xml:space="preserve" height="40"><g><path fill="#BB4230" d="M133.2,36.7c-2.2-7.9-5-15.5-11-21.5c-5.6-5.7-12-5.2-17,1.1c-2.6,3.3-4.6,6.9-6.4,10.7c-1.6-1.4-1.7-3.3-2.4-4.9c-2.4-5.9-5.1-11.6-9.7-16.1c-5.2-5.1-11-5.3-16.3-0.4C63,12.3,60,21.5,57.4,30.8c-9.7,34.9-10,70.3-3.7,105.8C55.9,149,59,161.4,66.2,172c7.4,10.9,16.3,12,24.2,0.2c2.6-3.9,4.7-8,6.3-12.4c0.5-1.3,0.5-2.9,2.1-3.8c1.7,3.8,3.7,7.5,6.2,10.8c4.9,6.4,11.2,6.9,17,1.3c3.7-3.5,6-7.9,7.9-12.5c5-12.1,7.3-24.8,8.6-37.7C141.5,90.4,140.7,63.3,133.2,36.7z M94.4,154.2c-2.3,1.6-4.4,3.5-7.7,2.2c-6-2.4-8.8-7.4-10.9-12.8c-6.8-17.3-8.5-35.5-8.4-53.9c0.1-17.3,1.9-34.5,8.4-50.9c1.6-4,3.8-7.7,7-10.8c1.9-1.7,4.1-1.9,5.8-2.6c4.8,0.1,8.6,4.7,7.5,8.6c-10.6,38.2-10.6,76.5-0.1,114.7C96.7,151.1,96.5,152.8,94.4,154.2z M131.2,126.4c-1.6,4.2-2.8,9.9-8.5,9.8c-5.8-0.1-7.2-5.6-8.9-10c-4.2-11.2-4.8-23-4.9-34.9c0.1-12,0.8-24,5.2-35.3c1.6-4.2,3.3-9.3,8.4-9.5c5.1-0.2,6.6,4.9,8.3,8.8c3,6.9,4.3,14.3,4.9,21.8C137.1,93.8,137,110.5,131.2,126.4z"></path></g> <path fill="#BB4230" d="M55.2,168.6C28.7,158.5,1.7,128.3,1.9,90.1C2,54,28.5,23.8,55.6,13.1C35.7,35.2,27,61.4,27.1,90.7C27.1,120,35.3,146.4,55.2,168.6z"></path> <path fill="#BB4230" d="M166.2,90.7c-0.4,6.5-0.8,12.9-3.1,19.1c-0.8,2.2-1.7,4.7-4.5,4.7c-2.6,0-3.6-2.4-4.2-4.4c-4.1-13-4.1-26.2,0-39.2c0.6-2,1.7-4.4,4.2-4.4c2.9-0.1,3.7,2.5,4.5,4.6C165.4,77.3,165.8,84,166.2,90.7z"></path></svg>
            <span class="text-danger e-eng-font demo e-light-bold ml-2 e-ts-h5">&nbsp; ScreeningHub</span>
          </div>
        </div>
        <div class="col col-5">
          <span class="e-mtavr-17 text-muted e-ts-16 d-flex justify-content-center align-items-center h-100">დამთხვევების სია</span>
        </div>
        <div class="col col-4 text-right">
          <div class="e-nusx-8 text-muted mr-2">
          <p class="mb-1 mt-3 text-muted">ძებნის პარამეტრი: <span class="e-eng-font text-primary">{{ investigatingRequest.firstName}} {{ investigatingRequest.lastName}}</span></p>
          <p class="text-muted">სქრინინგის თარიღი: <span class="e-eng-font text-primary">{{ investigatingRequest.recDate}}</span></p>
          </div>
        </div>
        <div class="col col-12 pb-5 pl-3 pr-3">
          <vue-good-table
            ref="requestsTable"
            :columns="apiVersion === 'V1' ? investigatingRequest.juridicalStatusId === 1 ? MTCH_Table_ColumnsNew : MTCH_Table_ColumnsNew_ent : MTCH_Table_Columns"
            :rows="MTCH_Table_Rows"
            class="vgt-table bordered condensed e-table-1 e-dynamic-filter e-ts-07rem"
            :search-options="{enabled: true, placeholder: 'ძებნის პარამეტრი'}"
            :sort-options="{enabled: true, initialSortBy: {field: 'score', type: 'desc'}}"
            :select-options="{
              enabled: true,
              selectOnCheckboxOnly: true,
              disableSelectInfo: true
               }"
            :pagination-options="{
                                    enabled: true,
                                    mode: 'records',
                                    perPage: 5,
                                    position: 'top',
                                    perPageDropdown: [50, 75, 100],
                                    dropdownAllowAll: false,
                                    setCurrentPage: 1,
                                    nextLabel: 'შემდეგი',
                                    prevLabel: 'წინა',
                                    rowsPerPageLabel: 'ნაჩვენები ჩანაწერების რაოდენობა',
                                    ofLabel: '-ჩანაწერი სულ',
                                    pageLabel: 'გვერდი', // for 'pages' mode
                                    allLabel: 'ყველა',
                                  }"
          >
          <template slot="table-row" slot-scope="props">
              <div v-if="props.column.field == 'Nationality'">
                <div v-if="investigatingRequest.juridicalStatusId === 1">
                  <ul class="list-unstyled" v-if="apiVersion === 'V1'">
                    <li v-for="natio in props.row.Nationality"  :key="natio.$index">{{ natio }}</li>
                  </ul>
                  <ul class="list-unstyled" v-else>
                    <li v-for="natio in props.row.Nationality"  :key="natio.$index">{{ natio }}</li>
                  </ul>
                </div>
                <div v-if="investigatingRequest.juridicalStatusId === 2">
                  <ul class="list-unstyled" v-if="apiVersion === 'V1'">
                    <li v-for="natio in props.row.Nationality"  :key="natio.id">{{ natio.countryName }}</li>
                  </ul>
                  <!-- {{props.row}} -->
                  <ul class="list-unstyled" v-else>
                    <li v-for="natio in props.row.Nationality"  :key="natio.id">{{ natio.countryName }}</li>
                  </ul>
                </div>
              </div>
               <div v-else-if="props.column.field == 'AdditionalNotes'" class="text-left">
                <ul class="list-unstyled">
                  <li v-for="n in props.row.distData" :key="n.$index">
                      <!-- <div v-for="c in n.categories" :key="c.name" class="badge badge-outline-danger ml-1 mr-1">{{c.name}}</div> -->
                      <div class="badge badge-outline-danger ml-1 mr-1 float-left">{{n}}</div>
                  </li>
                </ul>
                <ul class="list-unstyled">
                  <li v-for="n in props.row.datasets" :key="n.$index">
                      <!-- <div v-for="c in n.categories" :key="c.name" class="badge badge-outline-danger ml-1 mr-1">{{c.name}}</div> -->
                      <div class="badge badge-outline-danger ml-1 mb-1 float-left">{{n}}</div>
                  </li>
                </ul>
              </div>
              <div v-else-if="props.column.field == 'NameAlias'">
                  <span>{{ props.row.name}}</span><br/>
                  <span class="badge badge-secondary e-eng-font"><small>Alias Match: </small>{{ props.row.match }}</span>
                </div>
              <div v-else-if="props.column.field == 'BirthDate'">
                <ul class="list-unstyled" v-if="apiVersion === 'V1'">
                  <li v-for="bd in props.row.datesOfBirth"  v-bind:key="bd.$index">{{ bd }}</li>
                </ul>
              </div>
              <div v-else-if="props.column.field == 'Image'" class="text-center">
                  <img v-bind:src="props.row.profileImage" :id="props.row.qrCode" class="e-max-width-70">
                  <b-popover id="primaryPopover-container" container="primaryPopover-container" :target="props.row.qrCode" custom-class="popover" placement="right" triggers="hover focus">
                    <template #title> <span class="e-nusx-7">სურათის ორიგინალი</span></template>
                    <template>
                      <b-container fluid class="p-0 w-auto">
                        <div class="row">
                          <div class="col col-12">
                            <img v-bind:src="props.row.profileImage" class="img-fluid">
                          </div>
                        </div>
                      </b-container>
                  </template>
                  </b-popover>
                  <!-- <b-tooltip triggers="hover" target="tooltip-target-1" placement="right" class="b-tooltip-light tooltip-right">
                    <div class="col col-12">
                    <img v-bind:src="props.row.profileImage">
                    </div>
                  </b-tooltip> -->
                </div>
              <div v-else-if="props.column.field == 'DataCollectedDate'" class="text-left">
                <ul class="list-unstyled">
                  <li v-for="n in props.row.articles" :key="n.text">
                      {{n.dateCollected}}
                  </li>
                </ul>
              </div>
              <div v-else-if="props.column.field == 'functions'" class="text-left">
                <!-- <button type="button" class="btn btn-outline-danger icon-btn borderless" @click="ShowPersonalDetails(props.row)"><span class="lnr lnr-magnifier"></span></button> -->
                <button v-if="apiVersion === 0" type="button" class="btn btn-outline-danger icon-btn borderless" @click="ShowPersonalDetails(props.row)"><span class="lnr lnr-magnifier"></span></button>
                <button v-else type="button" class="btn btn-outline-danger icon-btn borderless" @click="loadProfile(props.row)"><span class="lnr lnr-magnifier"></span></button>
              </div>
              <!-- <div v-else-if="props.column.field == 'functions'" class="e-whitespace-nowrap">
                <button
                  class="btn btn-info icon-btn btn-sm"
                  title="სკანირების რეზულტატების ნახვა"
                  v-if="props.row.matchCount > 0"
                >
                  <span class="lnr lnr-magnifier"></span>
                </button>
              </div> -->
            </template>
          </vue-good-table>
        </div>
      </div>
    </section>
    </vue-html2pdf>
  </div>
</template>
<script>
import BaseService from '@/backend/vue-axios/axios.js'
import AddToWlBlItem from '../components/addToWLBLItem'
import PersonalDetails from '../components/personalDetails'
import moment from 'moment'
import BusinessDetails from '../components/businessDetails.vue'
import BusinessDetailsv3 from '../components/businessDetails3.vue'
import IndividualDetails from '../components/individualDetails.vue'
import RequestDetailsComponent from '../components/requestDetails.vue'
import VueHtml2pdf from 'vue-html2pdf'
export default {
  name: 'ClientScreeningDetails',
  metaInfo: {
    title: ' - კლიენტთა ბაზის სქრინინგის შედეგი'
  },
  // props: ['isinvestigating'],
  props: ['requestId'],
  components: {
    VueHtml2pdf,
    PersonalDetails,
    AddToWlBlItem,
    RequestDetailsComponent,
    BusinessDetails,
    BusinessDetailsv3,
    IndividualDetails
  },
  data () {
    return {
      header: {
        headers: {
          accept: 'text/plain',
          Authorization: 'Bearer ' + this.$store.getters.getAccessToken
        }
      },
      curTab: 'ConInfo',
      curTabbd: 'ConInfo',
      showBusinessDetails: false,
      businessDetails: {},
      loading: true,
      commentsLoading: false,
      CommentText: '',
      testData: {},
      countriesList: this.$store.getters.GetCountriesList,
      currentUser: this.$store.getters.GetCurrentUser,
      showPersonalDetails: false,
      personDetails: {},
      distinctData: ['a', 'b'],
      investigatingRequest: {},
      MTCH_Table_ColumnsNew_ent: [
        {
          label: 'QR კოდი',
          field: 'qrCode',
          thClass: 'e-mtavr-17 e-whitespace-nowrap e-ts-07rem',
          tdClass: 'e-ts-07rem',
          type: 'number'
        },
        {
          label: 'დამთხვევის %',
          field: 'score',
          thClass: 'e-mtavr-17 e-whitespace-nowrap e-ts-07rem',
          tdClass: 'e-ts-07rem',
          type: 'number'
        },
        {
          label: 'დასახელება',
          field: 'NameAlias',
          thClass: 'e-mtavr-17 e-whitespace-nowrap e-ts-07rem',
          tdClass: 'e-ts-07rem',
          type: 'text'
        },
        {
          label: 'ქვეყანა',
          field: 'Nationality',
          thClass: 'e-mtavr-17 e-whitespace-nowrap e-ts-07rem',
          tdClass: 'e-ts-07rem',
          type: 'text'
        },
        {
          label: 'სიის წყარო',
          // field: "person.forename " + "person.middlename " + "person.surname",
          field: 'AdditionalNotes',
          type: 'text',
          thClass: 'e-mtavr-17 e-whitespace-nowrap e-ts-07rem',
          tdClass: 'e-ts-07rem'
        },
        {
          label: 'ფუნქციები',
          // field: "person.forename " + "person.middlename " + "person.surname",
          field: 'functions',
          thClass: 'e-mtavr-17 e-whitespace-nowrap e-ts-07rem'
        }
      ],
      MTCH_Table_ColumnsNew: [
        {
          label: 'QR კოდი',
          field: 'qrCode',
          thClass: 'e-mtavr-17 e-whitespace-nowrap e-ts-07rem',
          tdClass: 'e-ts-07rem',
          type: 'number'
        },
        {
          label: 'სურათი',
          field: 'Image',
          thClass: 'e-mtavr-17 e-whitespace-nowrap e-ts-07rem',
          type: 'text'
        },
        {
          label: 'დამთხვევის %',
          field: 'score',
          thClass: 'e-mtavr-17 e-whitespace-nowrap e-ts-07rem',
          tdClass: 'e-ts-07rem',
          type: 'number'
        },
        {
          label: 'დასახელება',
          field: 'NameAlias',
          thClass: 'e-mtavr-17 e-whitespace-nowrap e-ts-07rem',
          tdClass: 'e-ts-07rem',
          type: 'text'
        },
        {
          label: 'დაბადების თარიღი',
          field: 'BirthDate',
          thClass: 'e-mtavr-17 e-whitespace-nowrap e-ts-07rem',
          tdClass: 'e-ts-07rem',
          type: 'text'
        },
        {
          label: 'სქესი',
          field: 'gender',
          thClass: 'e-mtavr-17 e-whitespace-nowrap e-ts-07rem',
          tdClass: 'e-ts-07rem',
          type: 'text'
        },
        {
          label: 'მოქალაქეობა / ქვეყანა',
          field: 'Nationality',
          thClass: 'e-mtavr-17 e-whitespace-nowrap e-ts-07rem',
          tdClass: 'e-ts-07rem',
          type: 'text'
        },
        {
          label: 'სიის წყარო',
          // field: "person.forename " + "person.middlename " + "person.surname",
          field: 'AdditionalNotes',
          type: 'text',
          thClass: 'e-mtavr-17 e-whitespace-nowrap e-ts-07rem',
          tdClass: 'e-ts-07rem'
        },
        {
          label: 'ფუნქციები',
          // field: "person.forename " + "person.middlename " + "person.surname",
          field: 'functions',
          thClass: 'e-mtavr-17 e-whitespace-nowrap e-ts-07rem'
        }
      ],
      // MTCH_Table_ColumnsNew: [
      //   {
      //     label: 'დამთხვევის %',
      //     field: 'score',
      //     thClass: 'e-mtavr-17 e-whitespace-nowrap e-ts-07rem',
      //     tdClass: 'e-ts-07rem',
      //     type: 'number'
      //   },
      //   {
      //     label: 'დასახელება',
      //     field: 'name',
      //     thClass: 'e-mtavr-17 e-whitespace-nowrap e-ts-07rem',
      //     tdClass: 'e-ts-07rem',
      //     type: 'text'
      //   },
      //   {
      //     label: 'სქესი',
      //     field: 'gender',
      //     thClass: 'e-mtavr-17 e-whitespace-nowrap e-ts-07rem',
      //     tdClass: 'e-ts-07rem',
      //     type: 'text'
      //   },
      //   {
      //     label: 'მოქალაქეობა',
      //     field: 'Nationality',
      //     thClass: 'e-mtavr-17 e-whitespace-nowrap e-ts-07rem',
      //     tdClass: 'e-ts-07rem',
      //     type: 'text'
      //   },
      //   {
      //     label: 'სიის წყარო',
      //     // field: "person.forename " + "person.middlename " + "person.surname",
      //     field: 'AdditionalNotes',
      //     type: 'text',
      //     tdClass: 'e-ts-07rem',
      //     thClass: 'e-mtavr-17 e-whitespace-nowrap e-ts-07rem'
      //   },
      //   {
      //     label: 'ფუნქციები',
      //     // field: "person.forename " + "person.middlename " + "person.surname",
      //     field: 'functions',
      //     tdClass: 'e-ts-07rem',
      //     thClass: 'e-mtavr-17 e-whitespace-nowrap e-ts-07rem'
      //   }
      // ],
      MTCH_Table_Columns: [
        {
          label: 'დამთხვევის %',
          field: 'score',
          thClass: 'e-mtavr-17 e-whitespace-nowrap e-ts-07rem',
          type: 'number'
        },
        {
          label: 'დასახელება',
          field: 'FullName',
          thClass: 'e-mtavr-17 e-whitespace-nowrap e-ts-07rem',
          type: 'text'
        },
        {
          label: 'მოქალაქეობა',
          field: 'Nationality',
          thClass: 'e-mtavr-17 e-whitespace-nowrap e-ts-07rem',
          type: 'text'
        },
        {
          label: 'სიის წყარო',
          // field: "person.forename " + "person.middlename " + "person.surname",
          field: 'AdditionalNotes',
          type: 'text',
          thClass: 'e-mtavr-17 e-whitespace-nowrap e-ts-07rem'
        },
        {
          label: 'ფუნქციები',
          // field: "person.forename " + "person.middlename " + "person.surname",
          field: 'functions',
          thClass: 'e-mtavr-17 e-whitespace-nowrap e-ts-07rem'
        }
      ],
      MTCH_Table_Rows: [],
      WHBL_item: {},
      user: {
        avatar: '1-small.png'
      },
      comments: [],
      possibleDataSets: [
        { db: 'SAN-CURRENT', count: 0 },
        { db: 'SAN-FORMER', count: 0 },
        { db: 'INS', count: 0 },
        { db: 'RRE', count: 0 },
        { db: 'POI', count: 0 },
        { db: 'REL', count: 0 },
        { db: 'SOE-CURRENT', count: 0 },
        { db: 'SOE-FORMER', count: 0 },
        { db: 'GRI', count: 0 },
        { db: 'ID', count: 0 },
        { db: 'CORP', count: 0 },
        { db: 'PEP-CURRENT', count: 0 }
      ],
      apiVersion: 0
    }
  },
  beforeCreate () {},
  created () {
    BaseService.GetRequestWithDetail(this.header, this.$route.query.clientRequestId)
      .then(res => {
        if (res.data.success) {
          res.data.result.request.recDate = moment(res.data.result.request.recDate).format('DD.MM.YYYY HH:mm:SS')
          this.investigatingRequest = res.data.result.request
          this.investigatingRequest.registrationCountry = this.$route.query.rowIdentRecCountry
          this.investigatingRequest.brthDate = this.$route.query.rowBirthDate === null ? '' : moment(this.$route.query.rowBirthDate).format('DD.MM.YYYY')
          this.investigatingRequest.IdentNumber = this.$route.query.rowIdentNumber
          this.investigatingRequest.address = this.$route.query.rowAddress
          this.investigatingRequest.registrationN = this.$route.query.rowRegNumber
          this.investigatingRequest.personalN = this.$route.query.rowPersonalN
          this.GetrequestUniqueId(this.$route.query.clientRequestId)
          this.WHBL_item = {
            id: 0,
            requestId: this.investigatingRequest.id,
            firstName: this.investigatingRequest.firstName,
            lastName: this.investigatingRequest.lastName,
            personalN: this.investigatingRequest.personalN,
            documentNumber: '',
            birthDate: this.investigatingRequest.brthDate === 'თარიღი ცარიელია' ? null : moment(this.investigatingRequest.brthDate).format('DD.MM.YYYY HH:mm:SS'),
            nationality: this.investigatingRequest.country,
            addingReasonId: 0,
            addingReason: '',
            additionalInfo: '',
            recDate: moment(Date.now()).format(),
            creatorUserId: this.currentUser.id,
            creatorUserName: this.currentUser.userName,
            status: true,
            statusChangeDate: null,
            statusChangeUserId: 0,
            statusChangeUserName: '',
            comment: '',
            organisationId: this.currentUser.organizationID,
            juridicalStatusId: 1,
            juridicalStatusDesc: '',
            deleteStatus: false,
            organisationUserId: null,
            registrationCountry: this.$route.query.rowIdentData
          }
          this.$store.commit('setWHBLItem', this.WHBL_item)
        }
      })
    // this.getMatchesByRequestID(this.$route.query.requestUniqueId, this.$route.query.clientRequestId)
  },
  computed: {
    chatUser () {
      for (let i = 0, l = this.contactsData.length; i < l; i++) {
        if (this.contactsData[i].username === this.chatData.user) return this.contactsData[i]
      }

      return {
        avatar: '',
        name: '',
        username: '',
        online: false,
        newMessages: 0
      }
    },
    chatContacts () {
      //
      // Sort contacts (online then offline)
      //
      return [].concat(
        // Online
        this.contactsData.reduce((c, i) => {
          if (i.online) c.push(i)
          return c
        }, []).sort(function (a, b) {
          const nameA = a.name.toUpperCase()
          const nameB = b.name.toUpperCase()

          if (nameA < nameB) return -1
          if (nameA > nameB) return 1
          return 0
        })
      ).concat(
        // Offline
        this.contactsData.reduce((c, i) => {
          if (!i.online) c.push(i)
          return c
        }, []).sort(function (a, b) {
          const nameA = a.name.toUpperCase()
          const nameB = b.name.toUpperCase()

          if (nameA < nameB) return -1
          if (nameA > nameB) return 1
          return 0
        })
      )
    }
  },
  methods: {
    changeTab (tab) {
      console.log('investii' + tab)
      this.curTab = tab
    },
    changeTabbd (tab) {
      console.log('investi' + tab)
      this.curTabbd = tab
    },
    onProgress (event) {
      console.log(`Processed: ${event} / 100`)
    },
    hasGenerated () {
      alert('PDF generated successfully!')
    },
    generatePDF () {
      this.$refs.html2Pdf.generatePdf()
    },
    loadProfile (Match) {
      this.curTab = 'ConInfo'
      this.curTabbd = 'ConInfo'
      this.loading = true
      if (this.investigatingRequest.juridicalStatusId === 1) {
        BaseService.LoadIndividualDetails(this.header, Match.resourceId)
          .then(res => {
            if (res.data.success) {
              this.showPersonalDetails = true
              this.personDetails = res.data.result
              this.personDetails.score = Match.score
              this.loading = false
              if (this.personDetails.evidences.length > 0) {
                this.possibleDataSets.forEach((possibleDataSet) => {
                  possibleDataSet.count = 0
                })
                this.personDetails.evidences.forEach(element => {
                  this.possibleDataSets.forEach((possibleDataSet) => {
                    if (element.datasets.includes(possibleDataSet.db)) {
                      possibleDataSet.count += 1
                    }
                  })
                })
              }
              this.personDetails.envidencePossibleDS = this.possibleDataSets
            } else if (res.data.result === null) {
              this.loading = false
            }
          })
      }
      if (this.investigatingRequest.juridicalStatusId === 2) {
        BaseService.LoadBusinessDetails(this.header, Match.resourceId)
          .then(res => {
            if (res.data.success) {
              this.showBusinessDetails = true
              this.businessDetails = res.data.result
              this.businessDetails.score = Match.score
              this.loading = false
              this.possibleDataSets.forEach((possibleDataSet) => {
                possibleDataSet.count = 0
              })
              if (this.businessDetails.evidences.length > 0) {
                this.businessDetails.evidences.forEach(element => {
                  this.possibleDataSets.forEach((possibleDataSet) => {
                    if (element.datasets.includes(possibleDataSet.db)) {
                      possibleDataSet.count += 1
                    }
                  })
                })
              }
              this.businessDetails.envidencePossibleDS = this.possibleDataSets
            }
          })
      }
    },
    GetrequestUniqueId (id) {
      BaseService.GetRequestByID(this.header, id)
        .then(res => {
          if (res.data.success) {
            this.getMatchesByRequestID(res.data.result.requestUniqueId, res.data.result.id)
          }
        })
    },
    AddToWhiteList () {
      // console.log(this.WHBL_item)
    },
    AddToBlackList (data) {},
    setRequestStatus (recId, statusId) {
      // HeaderParams.headers.Authorization = 'Bearer ' + this.$store.getters.getAccessToken
      BaseService.SetRequestStatus(this.header, recId, statusId)
        .then(res => {
          if (res.data.success) {
            this.investigatingRequest.status = statusId
            this.loadRequestDetails()
          }
        })
    },
    loadRequestDetails () {
      BaseService.GetRequestWithDetail(this.header, this.$route.query.clientRequestId)
        .then(res => {
          if (res.data.success) {
            res.data.result.request.recDate = moment(res.data.result.request.recDate).format('DD.MM.YYYY HH:mm:SS')
            this.investigatingRequest = res.data.result.request
            this.investigatingRequest.registrationCountry = this.$route.query.rowIdentRecCountry
            this.investigatingRequest.brthDate = this.$route.query.rowBirthDate === null ? '' : moment(this.$route.query.rowBirthDate).format('DD.MM.YYYY')
            this.investigatingRequest.IdentNumber = this.$route.query.rowIdentNumber
            this.investigatingRequest.address = this.$route.query.rowAddress
            this.investigatingRequest.registrationN = this.$route.query.rowRegNumber
            this.investigatingRequest.personalN = this.$route.query.rowPersonalN
            this.GetrequestUniqueId(this.$route.query.clientRequestId)
            this.WHBL_item = {
              id: 0,
              requestId: this.investigatingRequest.id,
              firstName: this.investigatingRequest.firstName,
              lastName: this.investigatingRequest.lastName,
              personalN: this.investigatingRequest.personalN,
              documentNumber: '',
              birthDate: this.investigatingRequest.brthDate === 'თარიღი ცარიელია' ? null : moment(this.investigatingRequest.brthDate).format('DD.MM.YYYY HH:mm:SS'),
              nationality: this.investigatingRequest.country,
              addingReasonId: 0,
              addingReason: '',
              additionalInfo: '',
              recDate: moment(Date.now()).format(),
              creatorUserId: this.currentUser.id,
              creatorUserName: this.currentUser.userName,
              status: true,
              statusChangeDate: null,
              statusChangeUserId: 0,
              statusChangeUserName: '',
              comment: '',
              organisationId: this.currentUser.organizationID,
              juridicalStatusId: 1,
              juridicalStatusDesc: '',
              deleteStatus: false,
              organisationUserId: null,
              registrationCountry: this.$route.query.rowIdentData
            }
            this.$store.commit('setWHBLItem', this.WHBL_item)
          }
        })
    },
    ShowPersonalDetails (rowData) {
      if (this.investigatingRequest.juridicalStatusId === 1) {
        this.showPersonalDetails = true
        this.personDetails = rowData
      }
      if (this.investigatingRequest.juridicalStatusId === 2) {
        this.showBusinessDetails = true
        this.businessDetails = rowData
      }
    },
    getMatchesByRequestID (uniqueId, id) {
      // BaseService.GetRequestWithDetail(this.header, id)
      //   .then(res => {
      //     console.log('aa')
      //     console.log(res)
      //     if (res.data.success) {
      //       this.investigatingRequest = res.data.result.request
      //     }
      //   })
      BaseService.GetMatchesByRequestId(this.header, uniqueId)
        .then(res => {
          this.GetCommentsByRequestId(id)
          if (res.data.result === null) {
            console.log('Responce NULL')
            this.loading = false
          } else {
            const responceJson = JSON.parse(res.data.result.responceJson)
            if (res.data.result.apiVersion === 'V1') {
              this.apiVersion = 'V1'
              if (this.investigatingRequest.juridicalStatusId === 1) {
                for (var i = 0; i < responceJson.results.matches.length; i++) {
                  responceJson.results.matches[i].Nationality = []
                  for (var c = 0; c < responceJson.results.matches[i].countries.length; c++) {
                    var ctrItem = this.countriesList.filter(cntry => {
                      if (cntry.twoCharCountryCode === responceJson.results.matches[i].countries[c]) {
                        responceJson.results.matches[i].Nationality.push(cntry.countryName)
                      }
                    })
                    // console.log(ctrItem)
                    // responceJson.results.matches[i].Nationality.push(ctrItem[0].countryNameGeo)
                  }
                  this.loading = false
                  this.MTCH_Table_Rows = responceJson.results.matches
                  // // const fildata = []
                  // // responceJson.results.matches[i].person.score = responceJson.results.matches[i].score
                  // // responceJson.results.matches[i].FullName = responceJson.results.matches[i].person.forename + ' ' + responceJson.results.matches[i].person.middlename + ' ' + responceJson.results.matches[i].person.surname
                  // this.MTCH_Table_Rows.push(responceJson.results.matches[i])
                  // // for (var o = 0; o < responceJson.matches[i].person.articles.length; o++) {
                  // //   for (var c = 0; c < responceJson.matches[i].person.articles[o].categories.length; c++) {
                  // //     if (!fildata.includes(responceJson.matches[i].person.articles[o].categories[c].name)) {
                  // //       fildata.push(responceJson.matches[i].person.articles[o].categories[c].name)
                  // //     }
                  // //   }
                  // // }
                  // // responceJson.matches[i].person.distData = fildata
                }
              }
              if (this.investigatingRequest.juridicalStatusId === 2) {
                for (var bi = 0; bi < responceJson.results.matchCount; bi++) {
                  for (c = 0; c < responceJson.results.matches[bi].countries.length; c++) {
                    responceJson.results.matches[bi].Nationality = []
                    ctrItem = this.countriesList.filter(cntry => {
                      return cntry.twoCharCountryCode === responceJson.results.matches[bi].countries[c]
                    })
                    responceJson.results.matches[bi].Nationality.push(ctrItem[c])
                  }
                  // responceJson.matches[bi].business.FullName = responceJson.matches[bi].business.businessName
                  this.MTCH_Table_Rows.push(responceJson.results.matches[bi])
                  // for (var bo = 0; bo < responceJson.matches[bi].business.articles.length; bo++) {
                  //   for (var bc = 0; bc < responceJson.matches[bi].business.articles[bo].categories.length; bc++) {
                  //     if (!fildata.includes(responceJson.matches[bi].business.articles[bo].categories[bc].name)) {
                  //       fildata.push(responceJson.matches[bi].business.articles[bo].categories[bc].name)
                  //     }
                  //   }
                  // }
                  this.loading = false
                }
              }
            } else {
              // console.log(responceJson)
              if (this.investigatingRequest.juridicalStatusId === 1) {
                for (i = 0; i < responceJson.recordsFound; i++) {
                  const fildata = []
                  responceJson.matches[i].person.score = responceJson.matches[i].score
                  responceJson.matches[i].person.FullName = responceJson.matches[i].person.forename + ' ' + responceJson.matches[i].person.middlename + ' ' + responceJson.matches[i].person.surname
                  this.MTCH_Table_Rows.push(responceJson.matches[i].person)
                  for (var o = 0; o < responceJson.matches[i].person.articles.length; o++) {
                    for (c = 0; c < responceJson.matches[i].person.articles[o].categories.length; c++) {
                      if (!fildata.includes(responceJson.matches[i].person.articles[o].categories[c].name)) {
                        fildata.push(responceJson.matches[i].person.articles[o].categories[c].name)
                      }
                    }
                  }
                  responceJson.matches[i].person.distData = fildata
                }
              }
              if (this.investigatingRequest.juridicalStatusId === 2) {
                if (responceJson.results.matches[bi].countries.length === 0) {
                  responceJson.results.matches[bi].Nationality = []
                } else {
                  responceJson.results.matches[bi].Nationality = []
                  for (c = 0; c < responceJson.results.matches[bi].countries.length; c++) {
                    ctrItem = this.countriesList.filter(cntry => {
                      return cntry.twoCharCountryCode === responceJson.results.matches[bi].countries[c]
                    })
                    responceJson.results.matches[bi].Nationality.push(ctrItem[0])
                  }
                }
                for (bi = 0; bi < responceJson.recordsFound; bi++) {
                  const fildata = []
                  responceJson.matches[bi].business.score = responceJson.matches[bi].score
                  responceJson.matches[bi].business.FullName = responceJson.matches[bi].business.businessName
                  this.MTCH_Table_Rows.push(responceJson.matches[bi].business)
                  for (var bo = 0; bo < responceJson.matches[bi].business.articles.length; bo++) {
                    for (var bc = 0; bc < responceJson.matches[bi].business.articles[bo].categories.length; bc++) {
                      if (!fildata.includes(responceJson.matches[bi].business.articles[bo].categories[bc].name)) {
                        fildata.push(responceJson.matches[bi].business.articles[bo].categories[bc].name)
                      }
                    }
                  }
                  responceJson.matches[bi].business.distData = fildata
                }
              }
              this.loading = false
            }
          }
          // if (res.data.result.responceJson === null) {
          //   console.log('Responce NULL')
          // } else {
          //   const responceJson = JSON.parse(res.data.result.responceJson)
          //   if (this.investigatingRequest.juridicalStatusId === 1) {
          //     for (var i = 0; i < responceJson.recordsFound; i++) {
          //       const fildata = []
          //       responceJson.matches[i].person.score = responceJson.matches[i].score ? responceJson.matches[i].score : '0'
          //       responceJson.matches[i].person.FullName = responceJson.matches[i].person.forename + ' ' + responceJson.matches[i].person.middlename + ' ' + responceJson.matches[i].person.surname
          //       this.MTCH_Table_Rows.push(responceJson.matches[i].person)
          //       for (var o = 0; o < responceJson.matches[i].person.articles.length; o++) {
          //         for (var c = 0; c < responceJson.matches[i].person.articles[o].categories.length; c++) {
          //           if (!fildata.includes(responceJson.matches[i].person.articles[o].categories[c].name)) {
          //             fildata.push(responceJson.matches[i].person.articles[o].categories[c].name)
          //           }
          //         }
          //       }
          //       responceJson.matches[i].person.distData = fildata
          //     }
          //   }
          //   if (this.investigatingRequest.juridicalStatusId === 2) {
          //     for (var bi = 0; bi < responceJson.recordsFound; bi++) {
          //       const fildata = []
          //       responceJson.matches[bi].business.score = responceJson.matches[bi].score
          //       responceJson.matches[bi].business.FullName = responceJson.matches[bi].business.businessName
          //       this.MTCH_Table_Rows.push(responceJson.matches[bi].business)
          //       for (var bo = 0; bo < responceJson.matches[bi].business.articles.length; bo++) {
          //         for (var bc = 0; bc < responceJson.matches[bi].business.articles[bo].categories.length; bc++) {
          //           if (!fildata.includes(responceJson.matches[bi].business.articles[bo].categories[bc].name)) {
          //             fildata.push(responceJson.matches[bi].business.articles[bo].categories[bc].name)
          //           }
          //         }
          //       }
          //       responceJson.matches[bi].business.distData = fildata
          //     }
          //   }
          // }
          // } else {
          //   console.log('error')
          // }
        })
    },
    GetCommentsByRequestId (id) {
      this.commentsLoading = true
      const reqParams = {
        headers: {
          accept: 'text/plain',
          Authorization: 'Bearer ' + this.$store.getters.getAccessToken
        }
      }
      BaseService.GetCommentsByRequestId(reqParams, id)
        .then(res => {
          this.commentsLoading = false
          // console.log(res)
          if (res.data.success) {
            this.comments = res.data.result
          } else {
            console.log('Error: ' + res)
          }
        })
    },
    AddComment (commentText) {
      this.commentsLoading = true
      const header = {
        headers: {
          accept: 'text/plain',
          Authorization: 'Bearer ' + this.$store.getters.getAccessToken
        }
      }
      const commentItem = {
        id: 0,
        commentText: commentText,
        userId: this.currentUser.id,
        userName: this.currentUser.userName,
        recDate: moment(Date.now()).format(),
        requestId: this.investigatingRequest.id,
        deleteStatus: false,
        organisationUserId: 0
      }
      BaseService.AddComment(header, commentItem)
        .then(res => {
          // console.log(res)
          if (res.data.success) {
            this.CommentText = ''
            this.GetCommentsByRequestId(this.investigatingRequest.id)
            this.commentsLoading = false
          }
        })
    },
    StopInvestigating () {
      this.$router.go(-1)
    }
  },
  filters: {
    momentTimeOnly: function (date) {
      return moment(date).format('HH:mm')
    },
    momentDateOnly: function (date) {
      return moment(date).format('DD.MM.YYYY')
    },
    momentDateAndTime: function (date) {
      return moment(date).format('HH:mm DD.MM.YYYY')
    }
  }
}
</script>
